/**
 * WordPress dependencies
 */
export * from '@wordpress/dom-ready';
import domReady from '@wordpress/dom-ready';
export default domReady;
